import { render, staticRenderFns } from "./PhysicalDriverLicense.vue?vue&type=template&id=c9b54822&"
import script from "./PhysicalDriverLicense.vue?vue&type=script&lang=js&"
export * from "./PhysicalDriverLicense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports